import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { DatePickerModule } from "primeng/datepicker";
import { InputTextModule } from "primeng/inputtext";

export interface UpdateProductionTaskPayload {
  taskTitle: string;
  dueDate: string | null;
}

/**
 * Confirmation dialog shown after a successful proof upload for a line item with an existing
 * production task.
 */
@Component({
  selector: "jni-update-production-task-modal",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    DatePickerModule,
    InputTextModule,
  ],
  templateUrl: "./update-production-task-modal.component.html",
  styleUrl: "./update-production-task-modal.component.scss",
})
export class UpdateProductionTaskModalComponent {
  visible = input(false);
  taskTitle = input("");
  dueDate = input<string | null>(null);
  latestLineStatusLabel = input("");
  isTaskUpdated = input(false);
  isUpdating = input(false);
  editableTaskTitle = "";
  editableDueDate: Date | null = null;

  visibleChange = output<boolean>();
  updateTask = output<UpdateProductionTaskPayload>();

  constructor() {
    effect(() => {
      this.editableTaskTitle = this.taskTitle();
      const dueDateValue = this.dueDate();
      this.editableDueDate = dueDateValue ? new Date(dueDateValue) : null;
    });
  }

  onUpdateTask(): void {
    if (this.isUpdating()) {
      return;
    }

    this.updateTask.emit({
      taskTitle: this.editableTaskTitle,
      dueDate: this.formatDueDateForApi(this.editableDueDate),
    });
  }

  private formatDueDateForApi(date: Date | null): string | null {
    if (!date) {
      return null;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  close(): void {
    this.visibleChange.emit(false);
  }
}
